import Link from 'next/link';
import { useRouter } from 'next/router';
import { MouseEvent, useMemo } from 'react';
import { IconNames } from '@pairy/pds-react';
import cn from 'classnames';

import * as Styled from './index.styles';

type Navigations = readonly {
  name: string;
  icon: IconNames;
  route: string;
  id?: string;
  onClick?: (e?: MouseEvent<HTMLDivElement>) => void;
  isDisabled?: boolean;
  className?: string;
}[];

interface Props {
  navigations: Navigations;
}

const Navigation = ({ navigations }: Props) => {
  const router = useRouter();

  const routerQueryToString = useMemo(() => {
    return Object.entries(router.query)
      .map(([key, value], index) => {
        if (index === 0) {
          return `?${key}=${value}`;
        }
        return `&${key}=${value}`;
      })
      .join('');
  }, [router.query]);

  const isCurrentPage = (route: string) => router.pathname.includes(route);

  return (
    <nav>
      <Styled.Ul>
        {navigations.map(
          ({ name, icon, route, id, onClick, isDisabled, className }) => (
            <li key={name} id={id}>
              <Link href={`${route}${routerQueryToString}`}>
                <Styled.NavButton
                  className={cn(className, {
                    active: isCurrentPage(route),
                    disabled: isDisabled,
                  })}
                  onClick={(e) => {
                    if (onClick) {
                      onClick(e);
                    }
                  }}
                >
                  <Styled.LinkIcon icon={icon} size={24} />
                  <Styled.Name variant="lg-semibold" color={'inherit'}>
                    {name}
                  </Styled.Name>
                </Styled.NavButton>
              </Link>
            </li>
          ),
        )}
      </Styled.Ul>
    </nav>
  );
};

export default Navigation;
